import {
    ETFTOKEN_RESPONSE, ETFTOKEN_RESPONSE_FAIL, ETFTRANSACTIONID_RESPONSE, ETFTRANSACTIONID_RESPONSE_FAIL
    , GETTICKERCODE_RESPONSE, GETTICKERCODE_RESPONSE_FAIL
} from "../types/etfTransaction"

const initialState = {
    etfToken: "",
    etfTransactionId: "",
    GetTickerCode: "",
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ETFTOKEN_RESPONSE:
            return { ...state, etfToken: action.payload }
        case ETFTOKEN_RESPONSE_FAIL:
            return { ...state, etfToken: action.payload }
        case ETFTRANSACTIONID_RESPONSE:
            return { ...state, etfTransactionId: action.payload }
        case ETFTRANSACTIONID_RESPONSE_FAIL:
            return { ...state, etfTransactionId: action.payload }
        case GETTICKERCODE_RESPONSE:
            return { ...state, GetTickerCode: action.payload }
        case GETTICKERCODE_RESPONSE_FAIL:
            return { ...state, GetTickerCode: action.payload }
        default:
            return state
    }

}
